module.exports = __webpack_public_path__ + "static/img/4.ecaa8d2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/4.png
// module id = /Osd
// module chunks = 0